/* eslint-disable no-console */
/* eslint-disable max-len */
export const initialState = {
	page           : 0,
	searchValue    : '',
	searchNotFound : '',
	loading        : false,
	menuItems      : {
		toggleFilter : 0,
		create       : 0,
		listGridview : 0
	},
	sort         : 0,
	breadCrubms  : [],
	selectedData : [],
	allSelected 	: false,
	count        : {
		myFolders   : 0,
		sharedItems : 0,
		employee    : 0,
		trash       : 0,
		myTemplates : 0
	},
	filter : ('1,2,3,4,5')

};
const common = {
	page           : 0,
	searchNotFound : '',
	selectedData   : [],
	allSelected    : false,
	searchValue    : '',
	loading        : false
};

const mediaDriveReducer = (state, action) =>
{
	switch (action?.type)
	{
		case 'updateReducer':
			return { ...state, ...action?.payload };
		case 'setMenuItems':
			return { ...state, menuItems: { ...state?.menuItems, ...action?.payload } };
		case 'setCount':
			return { ...state, count: { ...state?.count, ...action?.payload } };
		case 'tabChange':
			return {
				...state,
				...common,
				filter : ('1,2,3,4,5')
			};
		case 'updateSearch':
			return {
				...state,
				...common,
				searchValue : action.payload
			};
		case 'breadCrumb':
			return {
				...state,
				...common,
				loading : true
			};
		case 'reset':
			return initialState;
	}
};

export default mediaDriveReducer;